import { menu } from 'resolutions/all/menu'
import { loadSubMenu } from './fns/loadSubMenu'
import { unloadSubMenu } from './fns/unloadSubMenu'

export const desktop = {
  initialize() {
    console.log('DEBUG (resolutions.desktop): Initializing resolution.')
    MK.events.on('resolutions:desktop:addEventListeners', (_event) => {
      try {
        MK.DOM.fns.getElementsBy('querySelectorAll', [
          'li[data-menuroot]'
        ])

        console.log('DEBUG (resolutions.desktop.addEventListeners): Adding event listeners.')
        menu.submenu.onmouseleave = (event) => MK.events.emit('desktop:mainmenu:toggle:submenu', unloadSubMenu(event))

        MK.DOM.elements.querySelectorAll['li[data-menuroot]'].forEach(element => {
          element.onmouseenter = (event) => MK.events.emit('desktop:mainmenu:toggle:submenu', loadSubMenu(event))
        })

      } catch (error) {
        console.log('!!! ERROR (resolutions.desktop.addEventListeners): Error! Unable to add event listeners.')
        console.log(error)
        MK.captureException(error)
      }
    })

    MK.events.emit('resolutions:desktop:addEventListeners')
  }
}
